import apiClient from '@/api/apiClient'

// `tab` is the report's name on the server: bot, load, losses, agents, clients
export const getDashboard = (accountId, tab, params = {}) =>
  apiClient.get(`api/v1/accounts/${accountId}/dashboards/${tab}`, { params })

export const dashboardCsvUrl = (accountId, tab, params = {}) =>
  `/api/v1/accounts/${accountId}/dashboards/${tab}.csv?${new URLSearchParams(params)}`

// The threads behind a count: `user_id` narrows to one operator
export const getClientRatings = (accountId, params = {}) =>
  apiClient.get(`api/v1/accounts/${accountId}/dashboards/client_ratings`, {
    params,
  })
